import React from 'react';

function Header() {
  return (
    <header className="flex justify-center p-8 mb-4 bg-gray-900">
      <img 
        src="https://riverdalepoultry.ca/wp-content/themes/riverdale/assets/images/logo.png"
        alt="Riverdale Poultry"
        className="h-16"
      />
    </header>
  );
}

export default Header;